export interface BreadcrumbProps {
  items: {
    label: string;
    href?: string;
  }[];
}

export function Breadcrumb(_props: BreadcrumbProps) {
  return null;
}
